// extracted by mini-css-extract-plugin
module.exports = {"li":"installer_li__3jaGN","head":"installer_head__2Y7AJ"};